/*
    Creamos empleo
 */

(function (el) {
  //si no estamos en signup, nos vamos
  if (!el) {
    return;
  }

  //lanzamos aplicación
  new Vue({
    computed: {},
    components: {
      'jobs-form': JobsForm,
    },
    methods: {},
    template: `
    <div>
		<jobs-form></jobs-form>
    </div>
`,
  }).$mount(el);
})(document.getElementById('jobs-create'));
